import { createTheme } from "@mui/material/styles";

import { palette, fontFamily, fontSize } from "./tokens";

// Default theme configuration (dark theme)
export const defaultThemeConfig = {
  palette: {
    mode: "dark",
    primary: {
      main: palette.accent,
      contrastText: palette.accentContrast,
    },
    secondary: {
      main: "#1E1E1E",
      contrastText: "#ffffff",
    },
    accent: {
      main: "#262626",
      contrastText: "#ffffff",
    },
    default: {
      main: "#ffffff",
      contrastText: "#000000",
    },
    success: {
      main: "#0B964B",
      contrastText: "#ffffff",
    },
    background: {
      default: "#1E1E1E",
      paper: "#000000BE",
    },
  },
  typography: {
    fontFamily: fontFamily.body,
    text: {
      primary: "#FFFFFF",
      secondary: "#050505",
      accent: palette.accent,
    },
    subtitle1: {
      fontSize: fontSize.xs,
    },
    body1: {
      fontWeight: 500,
      fontSize: fontSize.sm,
    },
    body2: {
      fontWeight: 400,
      color: palette.accent,
    },
    button: {
      textTransform: "none", // Optional: Remove uppercase from buttons
    },
  },
  // shape: {
  //   borderRadius: 25,
  // },
};

// Create the default theme for backward compatibility
export const theme = createTheme(defaultThemeConfig);
